export default class MyUploadAdapter {

    // Creates a new adapter instance.
    constructor( loader, options ) {
        // FileLoader instance to use during the upload.
        this.loader = loader;

        // The configuration of the adapter.
        this.options = options;
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then( file => new Promise( ( resolve, reject ) => {
                this._initRequest();
                this._initListeners( resolve, reject, file );
                this._sendRequest( file );
            } ) );
    }

    // Aborts the upload process.
    abort() {
        if ( this.xhr ) {
            this.xhr.abort();
        }
    }

    // Initializes the `XMLHttpRequest` object using the URL specified as
    _initRequest() {
        const xhr = this.xhr = new XMLHttpRequest();

        xhr.open( 'POST', this.options.uploadUrl, true );
        xhr.responseType = 'json';
    }

    // Initializes XMLHttpRequest listeners
    _initListeners( resolve, reject, file ) {
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = `Couldn't upload file: ${ file.name }.`;

        xhr.addEventListener( 'error', () => reject( genericErrorText ) );
        xhr.addEventListener( 'abort', () => reject() );
        xhr.addEventListener( 'load', () => {
            const response = xhr.response;

            if ( !response || response.error ) {
                return reject( response && response.error && response.error.message ? response.error.message : genericErrorText );
            }

            resolve( response.url ? { default: response.url } : response.urls );
        } );

        // Upload progress when it is supported.
        /* istanbul ignore else */
        if ( xhr.upload ) {
            xhr.upload.addEventListener( 'progress', evt => {
                if ( evt.lengthComputable ) {
                    loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                }
            } );
        }
    }

    // Prepares the data and sends the request.
    _sendRequest( file ) {
        // Set headers if specified.
        const headers = this.options.headers || {};

        for ( const headerName of Object.keys( headers ) ) {
            this.xhr.setRequestHeader( headerName, headers[ headerName ] );
        }

        // Prepare the form data.
        const data = new FormData();

        data.append( 'image', file );

        // Send the request.
        this.xhr.send( data );
    }
}
